<template>
  <div>
    <div style="float: right">
      <datetime-range id="custom-datetime-range" :allow-clear="false" :default-value="datetimeRange" @ok="
        v => {
          datetimeRange = v
        }
      "></datetime-range>
    </div>
    <div style="clear: both"></div>
    <div class="module-container" style="height: 370px; margin: 16px 1px 0 1px">
      <log-chart-card :get-func="getTrendFunc" :datetime-range="datetimeRange"></log-chart-card>
    </div>

    <div class="module-container" style="min-height: 400px; margin: 16px 1px 0 1px">
      <div class="module-header" style="margin-bottom: 14px">
        详细日志表
      </div>
      <log-table :datetime-range="datetimeRange" :columns="columns" :get-func="getTableFunc"></log-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getService3rdLogList, getService3rdTrend } from '@/api/log'
import DatetimeRange from '@/components/DatetimeRange'
import LogChartCard from './modules/LogChartCard.vue'
import LogTable from './modules/LogTable.vue'

export default {
  name: 'ServiceInterfaceLog',
  components: {
    DatetimeRange,
    LogChartCard,
    LogTable
  },
  data() {
    return {
      datetimeRange: [moment().subtract(1, 'hour'), moment()],
      getTrendFunc: getService3rdTrend,
      getTableFunc: getService3rdLogList,
      columns: [
        // {
        //   dataIndex: 'timestamp',
        //   title: '采集时间',
        //   width: 200,
        //   scopedSlots: {
        //     customRender: 'timestamp'
        //   }
        // },
        // {
        //   dataIndex: 'hostip',
        //   title: 'IP 地址',
        //   width: 160,
        //   key: 'hostip',
        //   scopedSlots: {
        //     filterDropdown: 'filterDropdown',
        //     filterIcon: 'filterIcon',
        //     customRender: 'hostip'
        //   }
        // },
        {
          dataIndex: 'time_local',
          title: '请求时间',
          width: 160,
          scopedSlots: {
            customRender: 'timeLocal'
          }
        },
        {
          dataIndex: 'service_request',
          title: '请求监控识别 ID',
          width: 160,
          key: 'service_request',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'serviceRequest'
          }
        },

        {
          dataIndex: 'related_services',
          title: '业务系统',
          width: 200,
          key: 'related_services',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'related_services'
          }
        },
        {
          dataIndex: 'module_request',
          title: '请求模块名称',
          width: 160,
          key: 'module_request',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'moduleRequest'
          }
        },
        {
          dataIndex: 'service_response',
          title: '响应监控识别 ID',
          width: 160,
          key: 'service_response',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'serviceResponse'
          }
        },
        {
          dataIndex: 'module_response',
          title: '响应接口名称',
          width: 160,
          key: 'module_response',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'moduleResponse'
          }
        },
        {
          dataIndex: 'request_url',
          title: '请求地址',
          width: 160,
          key: 'request_url',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'requestUrl'
          }
        },
        {
          dataIndex: 'status',
          title: '状态',
          width: 120,
          key: 'status',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'status'
          }
        },
        {
          dataIndex: 'info',
          title: '具体描述',
          width: 120,
          key: 'info',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'info'
          }
        }
      ]
    }
  }
}
</script>

<style lang="less">
.module-container {
  position: relative;
  background: #fff;
  border-radius: 6px;
  padding: 16px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;
}
</style>
